import { useState } from 'react';

import { useIsMobileApp } from './useIsMobileApp.ts';
import { useLifecycle } from './useLifecycle.ts';

export const useDisable3D = () => {
  const { isMobileApp } = useIsMobileApp();
  const { lifecycle } = useLifecycle();
  const [disable3D, setDisable3D] = useState(
    lifecycle?.disable3D || isMobileApp
  );
  return { disable3D, setDisable3D };
};
